export var CURRENCIES = {
    TRY: "TRY",
    USD: "USD",
    EUR: "EUR",
    GBP: "GBP",
    JPY: "JPY",
    mBTC: "mBTC",
};
